<template>
  <div v-if="usableSpace" data-test-attr :class="[$style.item, $style.xSmallHide]">
    <div :class="$style.label">
      {{ listingWithFloorSpace ? t('listingCharacteristic.totalFloorSpace') : t('SURFACE') }}
    </div>
    <div :class="$style.value">
      <div :class="$style.valueIcon">
        <HgIcon icon="Square" size="large" />
      </div>
      {{ usableSpace }} <small>m<sup>2</sup></small>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HgIcon, hgNumber, HgSupportedLanguage } from '@smg-real-estate/domus';
import { Listing } from '@smg-real-estate/hg-rets-schema';
import { getListingSpace, isListingWithFloorSpace } from '@smg-real-estate/hg-search-libs';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

defineOptions({
  name: 'SpotlightAttributesUsableSpace',
});

interface Props {
  listing: Listing;
}

const props = defineProps<Props>();

const listingWithFloorSpace = computed((): boolean => {
  return isListingWithFloorSpace(props.listing);
});

const usableSpace = computed((): string | undefined => {
  const listingSpace = getListingSpace(props.listing);

  if (!listingSpace) {
    return;
  }

  return hgNumber(listingSpace, locale.value as HgSupportedLanguage);
});
</script>

<style module lang="scss">
@import './SpotlightAttributes';
</style>
